(function(){

    if(gsap && ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);

        const gsapConfig = {
            animate: true,
            fast: 0.5,
            slow: 1,
            sloth: 2,
            stagger: {
              tight: .1,
              default: .2,
            }
        }

        const animatables = document.querySelectorAll('[data-gsap]');

        // QUICKLY DISABLE ALL ANIMATIONS
        if(gsapConfig.animate !== true) return;

        if(window.Shopify.designMode) {
            gsap.set(animatables,{
                opacity: 1,
                y: 0
            });

            animatables.forEach(function(element){
                const staggerItems = element.querySelectorAll('[data-gsap-stagger-item]');
                if(staggerItems && staggerItems.length)
                gsap.set(staggerItems, {
                    opacity: 1,
                    y: 0
                });
            })


        }

        animatables.forEach((element) => {
            const baseAnimation = {
                scrollTrigger: element,
                opacity: 1,
                duration: gsapConfig.fast,
            };

            // STAGGERED ANIMATIONS
            if(element.hasAttribute('data-gsap-stagger')) {
                const staggerKey = element.getAttribute('data-gsap-stagger');
                const staggerItems = element.querySelectorAll('[data-gsap-stagger-item]');

                if(!staggerItems && !staggerItems.length){
                    console.warn('No stagger items found, looking for [data-gsap-stagger-item] in ', element);
                     return;
                }

                const staggerTiming = gsapConfig.stagger[staggerKey] ? gsapConfig.stagger[staggerKey] : gsapConfig.stagger.default;
                const extraAnimationValues = {};

                if (element.hasAttribute('data-gsap-y')) {
                    extraAnimationValues['y'] = 0;
                }



                gsap.to(staggerItems, {
                    ...baseAnimation,
                    ...extraAnimationValues,
                    stagger: staggerTiming
                });
            } else {
                // SIMPLE ANIMATIONS
                const extraAnimationValues = {};

                if (element.hasAttribute('data-gsap-y')) {
                    extraAnimationValues['y'] = 0;
                }

                gsap.to(element, {
                    ...baseAnimation,
                    ...extraAnimationValues,
                });
            }
        });
    }
})();